var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.25V22.75C20 20.8644 20 19.9216 19.4142 19.3358C18.8284 18.75 17.8856 18.75 16 18.75H12.75C10.8644 18.75 9.92157 18.75 9.33579 19.3358C8.75 19.9216 8.75 20.8644 8.75 22.75V26.25",
    stroke: "url(#paint0_linear_7404_66009)",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10H15",
    stroke: "url(#paint1_linear_7404_66009)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.75C3.75 6.92157 3.75 5.50736 4.62868 4.62868C5.50736 3.75 6.92157 3.75 9.75 3.75H20.4216C20.8303 3.75 21.0347 3.75 21.2185 3.82612C21.4022 3.90224 21.5468 4.04676 21.8358 4.33579L25.6642 8.16421C25.9532 8.45324 26.0978 8.59776 26.1739 8.78153C26.25 8.9653 26.25 9.16968 26.25 9.57843V20.25C26.25 23.0784 26.25 24.4926 25.3713 25.3713C24.4926 26.25 23.0784 26.25 20.25 26.25H9.75C6.92157 26.25 5.50736 26.25 4.62868 25.3713C3.75 24.4926 3.75 23.0784 3.75 20.25V9.75Z",
    stroke: "url(#paint2_linear_7404_66009)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7404_66009",
    x1: 14.375,
    y1: 14.5252,
    x2: 6.20232,
    y2: 25.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7404_66009",
    x1: 11.875,
    y1: 9.43669,
    x2: 11.4788,
    y2: 11.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7404_66009",
    x1: 15,
    y1: -8.92449,
    x2: -10.349,
    y2: 13.5755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.9aa568540925f4e52f6fd502d30cfcaa.svg";
export { ForwardRef as ReactComponent };